export default __webpack_public_path__ + "static/media/img6.5057c232.jpg";